var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlfanLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 27,
    viewBox: "0 0 74 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "logo-home.738dde1c 1",
    clipPath: "url(#clip0_5211_40463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5211_40463",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 74,
    height: 27
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_102_497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M73.8127 0H0V27H73.8127V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5211_40463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.1062 12.9852C17.0255 9.97042 11.9432 6.95776 6.86509 3.93861C6.5041 3.72423 6.37103 3.78525 6.37208 4.23507C6.38255 7.32118 6.37784 10.4073 6.37784 13.4934C6.37784 16.5703 6.37784 19.6467 6.37784 22.7236C6.37784 22.7987 6.37312 22.8743 6.37941 22.9488C6.39722 23.1605 6.50881 23.2285 6.6922 23.1405C6.74983 23.1129 6.80327 23.0768 6.85828 23.0438C8.11876 22.297 9.37978 21.5502 10.6403 20.8023C14.461 18.5359 18.2818 16.2695 22.1015 14.0015C22.585 13.7142 22.585 13.2693 22.1062 12.9852ZM8.90094 18.8583C8.90094 15.2748 8.90094 11.7222 8.90094 8.12416C11.9186 9.91372 14.9142 11.6903 17.9502 13.4907C14.922 15.2867 11.9254 17.0644 8.90094 18.8583Z",
    fill: "url(#paint0_linear_5211_40463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.58911 1.99999C2.49941 1.36117 1.41547 0.712634 0.327867 0.0700351C0.101545 -0.0638846 0.0114351 -0.00988455 0.00776788 0.260115C0.00252896 0.653775 0.00619622 1.04743 0.00619622 1.44109C0.00619622 1.83475 0.0109112 2.22841 0.00357675 2.62207C0.000433388 2.77867 0.0433927 2.88073 0.183272 2.96281C1.25726 3.59191 2.326 4.23019 3.39841 4.86253C3.65616 5.01427 3.77142 4.94731 3.77352 4.64221C3.77771 3.87379 3.77247 3.10483 3.77718 2.33641C3.77823 2.17819 3.72689 2.08099 3.58911 1.99999Z",
    fill: "url(#paint1_linear_5211_40463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.39499 22.1371C2.32258 22.7694 1.25383 23.4077 0.179854 24.0368C0.0399747 24.1189 -0.00298458 24.221 0.000158781 24.3776C0.0074933 24.7712 0.00277825 25.1649 0.00277825 25.5585C0.00277825 25.9522 -0.000889006 26.3459 0.00434993 26.7395C0.00801719 27.0095 0.0976027 27.0635 0.324449 26.9296C1.41205 26.2875 2.49599 25.639 3.58569 24.9996C3.72399 24.9186 3.77481 24.8214 3.77429 24.6638C3.76957 23.8953 3.77534 23.1264 3.77062 22.358C3.76852 22.0523 3.65274 21.9854 3.39499 22.1371Z",
    fill: "url(#paint2_linear_5211_40463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M38.9662 8.27914V18.9852H36.3221V17.7308C35.5876 18.7038 34.4335 19.2449 33.0279 19.2449C30.0904 19.2449 27.9917 16.8657 27.9917 13.643C27.9917 10.4202 30.0899 8.041 33.0279 8.041C34.4759 8.041 35.651 8.62474 36.364 9.61996V8.27914H38.9662ZM36.1754 13.643C36.1754 11.6099 34.8537 10.68 33.5523 10.68C32.0833 10.68 30.8663 11.8264 30.8663 13.643C30.8663 15.4595 32.0833 16.5843 33.5523 16.5843C34.8537 16.5843 36.1754 15.6977 36.1754 13.643Z",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M40.8628 3.57633L43.6955 1.89909V18.9852H40.8628V3.57633Z",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M49.0527 6.78671V8.27927H51.34V10.7449H49.0527V18.9853H46.22V10.7449H44.751V8.27927H46.22V6.52755C46.22 3.78057 47.8147 2.50455 50.2278 2.50455C50.8784 2.50455 51.3819 2.61255 51.7806 2.74269V5.18673C51.4657 5.14353 51.2143 5.12193 50.9413 5.12193C49.6824 5.12139 49.0527 5.55393 49.0527 6.78671Z",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M62.3676 8.27914V18.9852H59.7235V17.7308C58.989 18.7038 57.8349 19.2449 56.4293 19.2449C53.4918 19.2449 51.3931 16.8657 51.3931 13.643C51.3931 10.4202 53.4913 8.041 56.4293 8.041C57.8773 8.041 59.0524 8.62474 59.7654 9.61996V8.27914H62.3676ZM59.5768 13.643C59.5768 11.6099 58.255 10.68 56.9537 10.68C55.4847 10.68 54.2677 11.8264 54.2677 13.643C54.2677 15.4595 55.4847 16.5843 56.9537 16.5843C58.255 16.5843 59.5768 15.6977 59.5768 13.643Z",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M73.8111 12.3453V18.9852H70.9991V12.7347C70.9991 11.5019 70.2231 10.6584 69.0686 10.6584C67.9147 10.6584 67.0961 11.5019 67.0961 12.7347V18.9852H64.2637V8.27914H66.8656V9.25222C67.5787 8.51674 68.6278 8.041 69.9081 8.041C72.3422 8.041 73.8111 9.7717 73.8111 12.3453Z",
    fill: "#050505"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5211_40463",
    x1: -0.456863,
    y1: 0.468626,
    x2: 15.4693,
    y2: 18.3232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5211_40463",
    x1: -0.0826037,
    y1: 0.134733,
    x2: 15.8435,
    y2: 17.9893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5211_40463",
    x1: -10.6716,
    y1: 9.58022,
    x2: 5.25449,
    y2: 27.4348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5211_40463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 27,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlfanLogo);
export default __webpack_public_path__ + "static/media/alfan_logo.aaca01a9252465c912f4bf18dad9fa8d.svg";
export { ForwardRef as ReactComponent };